<div class="auth-wrapper modal-content cc-active">
    <!-- The top -->
    <div class="cc-top">
        <div class="user-image pb-5" *ngIf="(isLoggedIn$ | async)">
            <img [src]="( userDetails$ | async)?.photoUrl" alt="Member User Logo"/>
        </div>
        <h2 *ngIf="(isLoggedIn$ | async)">Hi {{ (userDetails$ | async)?.displayName ? (userDetails$ | async )?.displayName: 'Hello...'}}!</h2>
        <h2 class="cc-h2" *ngIf="! (isLoggedIn$ | async)">Login</h2>
        <div class="cc-custom-separator"></div>
        <small *ngIf="!(isLoggedIn$ | async)">Login with your most active social media account!<span class="cc-tooltip mx-3" 
                    ngbTooltip="Login with your most active social media account, in order to see more recommendations." 
                    [autoClose]="true"
                    triggers="click">&nbsp;</span></small>
        <small *ngIf="(isLoggedIn$ | async)">Kickstart your journey now!
            <span class="cc-tooltip mx-3" 
                    ngbTooltip="Login with your most active social media account, in order to see more recommendations." 
                    [autoClose]="true"
                    triggers="click">&nbsp;</span>
        </small>
    </div>

    <!-- The content -->
    <div class="cc-content">
        <!-- If not logged in -->
        <div *ngIf="! (isLoggedIn$ | async)">

            <div id="firebaseui-auth-container"></div>
            <div id="loader" class="text-center">Loading...</div>
            <hr class="hr-text" data-content="OR" *ngIf="enableEmailAuth">
            <form class="form-submit mt-5 w-80" id="signInForm" 
                [formGroup]="signInForm" 
                #ngForm="ngForm" 
                (ngSubmit)="sendRegistrationLink()" 
                *ngIf="enableEmailAuth">

                <input type="email" 
                    class="form-control-input col text-center" 
                    id="email"
                    name="email"
                    formControlName="email"
                    value=""
                    placeholder="email address"     
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    ngbTooltip="Login by entering your email, then click on the email verification link.">
               
                <p *ngIf="checkEmail" class="text-center">Please check your email.</p>
                <div class="form-group text-center mt-3">
                    <button type="submit" class="cc-button-primary btn-block login-submit-button">Signup / Login</button>
                </div>  
            </form>
            
        </div>
        <!-- If member is logged in -->
        <div class="sub-container" *ngIf="isLoggedIn$ | async">
            <div class="row">
                <button type="button" class="btn btn-primary" (click)="goTo( urls.DECISION )">Start</button>    
            </div>
            <div class="row">
                <button type="button" class="btn btn-primary" (click)="goTo( urls.PRICING )">Price Plan</button>    
            </div>
            <div class="row">
                <button type="button" class="btn btn-secondary" (click)="logout()">Logout</button>
            </div>
        </div>
    </div>
</div>
